


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';
import { IMeasurementDto, MeasurementStatus } from '@/data/web-api-client';


@Component({
  components: {
    Popup,
  },
})
export default class MeasurementStartPopup extends Vue {
    @Prop({ required: true })
    private data!: IMeasurementDto;
    private show: boolean = false;

    private created() {
        this.show = this.data.status === MeasurementStatus.Open;
    }

    private start() {
        this.$emit('start');
        this.show = false;
    }

    @Watch('data', { deep: true })
    private onDataChanged() {
        this.show = this.data.status === MeasurementStatus.Open;
    }
}
